var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDog105(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_105"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_105",
    "data-name": 105,
    className: "cls-2",
    d: "M49.37,5.06C60.55-1.29,75.8,1,82.08,15.27c6,13.61-1.66,30.38-7.63,42.61C68.37,70.33,61,88.31,48.3,95.33c-12.38,6.86-34.08,1.74-32.48-14.76,1.49-15.28,7-29.86,13.23-43.77C33.88,26,38.48,11.24,49.37,5.06Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "cat_302"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -3,
    y: -59,
    width: 100,
    height: 100
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog105);
export default __webpack_public_path__ + "static/media/dog_105.b6088fb81ffac7ee84b86fdf8ef0d02f.svg";
export { ForwardRef as ReactComponent };